import type { ReactNode} from "react";
import { useCallback, useState } from "react";
import type { WSRequest } from "whole-shared";

import { ws } from "../ws";

export const Loading = () => <div className="full-screen" style={{ alignContent: "center", textAlign: "center" }}>
  <img src="/loading.gif" width="50" />
</div>;

export const NotFound = () => <div>Not found</div>;

export const PopUp = ({ children }: { children: ReactNode }) => <div className="full-screen" style={{ backgroundColor: "#24242480", cursor: "not-allowed", zIndex: 10 }}>
  {children}
</div>;

interface RequestButtonProps {
  disabled?: boolean;
  onRequest?: () => void;
  onResponse?: (request: WSRequest) => void;
  request: WSRequest;
  style?: React.CSSProperties;
  text: string;
}

export const RequestButton = ({ disabled, onRequest, onResponse, request, style, text }: RequestButtonProps) => {
  const [requested, setRequested] = useState(false);

  const handleClick = useCallback(() => {
    if(
      ws.request(request, response => {
        setRequested(false);
        onResponse?.(response);
      })
    ) {
      setRequested(true);
      onRequest?.();
    }
  }, [request, onResponse, onRequest]);

  return <div style={{ ...style, alignSelf: requested ? "start" : "baseline", display: "inline-block" }}>
    {requested ? <img src="/loading.gif" width="40" /> : <button disabled={disabled} onClick={handleClick}>
      {text}
    </button>}
  </div>;
};
